// Los 10 slots fijos de foto por pregunta (item). Los usan actions.js (addImage) y OccurrenceItemAddonDialog.vue.
// OccurrenceItemAddonsSection.vue todavia tiene una copia propia de la lista en pictureAddons (legado, ver CLAUDE.md "Codigo nuevo vs.
// codigo legado"): unificarla es una migracion aparte, fuera de alcance de TKT-436.
export const PICTURE_ADDON_TYPES = [
  'picture',
  'second_picture',
  'third_picture',
  'fourth_picture',
  'fifth_picture',
  'sixth_picture',
  'seventh_picture',
  'eighth_picture',
  'ninth_picture',
  'tenth_picture'
]

// Mismo criterio que OccurrenceItemAddonsSection.vue (pictureAddons): un slot cuenta como ocupado
// si tiene respuesta en memoria o en IndexedDB offline.
export function countOccupiedPictureSlots (addonsForItem = []) {
  return PICTURE_ADDON_TYPES.filter(type =>
    addonsForItem.some(addon => addon.type === type && (addon.answer || addon.imageRefIndexeddb))
  ).length
}
